/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import Button from 'material-ui/Button';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import red from 'material-ui/colors/red';

import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemText from 'material-ui/List/ListItemText';

import CreateIcon from 'material-ui-icons/Create';

import { capitalize } from "../utils/text";

import userIcon from "../assets/images/icons/default-user-avatar.png";


import Grid from 'material-ui/Grid';
import { withRouter } from 'react-router';
import { translate } from "react-i18next";

import {
  getUserStart,
  saveProducingSmartMeterRead,
  setUnit,
  getAllConsumingSites
} from '../actions'

import { checkUserIsAdmin } from '../utils/user/checkAdmin/CheckAdmin';
import { getUserDbId } from '../utils/user/info';
import { enums } from '../enums/index';

/**
 * Common component import
 */
import LoadingCircle from "../components/commons/LoadingCircle";
const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
    height: '100%'
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  card: {
    //maxWidth: 400,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
});

class User extends React.Component {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  static defaultProps = {
    zoom: 11
  };

  state = {
    anchorEl: null,
    allConsumingSites: []
  };

  getMapOptions = (maps) => {

    return {
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: false,
      styles: [{
        featureType: "poi.business",
        elementType: "labels",
        stylers: [{
          visibility: "off"
        }]
      }],
      gestureHandling: "greedy",
      disableDoubleClickZoom: true,
      minZoom: 1,
      maxZoom: 18,

      mapTypeControl: true,
      mapTypeId: maps.MapTypeId.SATELLITE,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [
          maps.MapTypeId.ROADMAP,
          maps.MapTypeId.SATELLITE,
          maps.MapTypeId.HYBRID
        ]
      },

      zoomControl: true,
      clickableIcons: false
    };
  }



  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  componentWillMount = () => { };
  componentDidMount = async () => {

    if (this.props.isAuthenticated) {
      const { match: { params } } = this.props;
      this.props.getUserStart(params.userId);
      const allConsumingSites = await getAllConsumingSites();
      this.setState({ allConsumingSites: allConsumingSites });
    } else {
      this.props.history.push('/')
    }
  };

  renderUpdateButton() {
    const { classes, user, isAuthenticated, match: { params } } = this.props;

    if (checkUserIsAdmin(isAuthenticated, user)) {
      return (
        <Button
          variant="fab"
          color="primary"
          aria-label="update"
          className={classes.button}
          style={{
            margin: 0,
            bottom: 'auto',
            right: 48,
            top: 85,
            left: 'auto',
            position: 'fixed',
          }}
          onClick={() => { this.props.history.push('/users/update/' + params.userId) }}
        >
          <CreateIcon />
        </Button>
      )
    } else return false;
  }

  render() {
    const { classes, currentUser, loading } = this.props;

    if (loading) {
      return (
        <div className={classes.root}>
          <LoadingCircle type="buttonProgress" classes={classes} />
        </div>
      );
    }

    if (!currentUser || !currentUser.app_metadata) {
      return (
        <div className={classes.root}>
          Error - User not available
        </div>
      );
    }
    const userLogo = currentUser.user_metadata.pictureFileName ? process.env.REACT_APP_API_URL + '/static/users/' + currentUser.user_metadata.pictureFileName : userIcon;

    let currentUserFullName = (currentUser.user_metadata && currentUser.user_metadata.firstname) ? capitalize(currentUser.user_metadata.firstname): "";
    currentUserFullName += (currentUser.user_metadata && currentUser.user_metadata.lastname) ? " " + capitalize(currentUser.user_metadata.lastname) : "";
    currentUserFullName += (currentUser.user_metadata && currentUser.user_metadata.username) ? " (aka "+currentUser.user_metadata.username+")" : "";

    let currentUserOganizationName = (currentUser.user_metadata && currentUser.user_metadata.organization && currentUser.user_metadata.organization.name) ? currentUser.user_metadata.organization.name : "";


    return (
      <div className={classes.root}>

        {this.renderUpdateButton()}
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={userIcon} style={{ maxHeight: 20 }} />}
                title="User information"
              />
              <CardContent>
                <Grid container spacing={24}>
                  <Grid item xs={12}>
                    <div className={classes.demo}>
                      <div style={{ textAlign: "center" }}>
                        <img src={userLogo}
                        style = {{ height: 60, width: 60, borderRadius: "50%", border: "1px solid rgba(0, 0, 0, 0.54)" }}
                        onError={(e)=>{e.target.onerror = null; e.target.src = userIcon}}
                        />
                      </div>
                      <List dense>
                        <ListItem style={{ textAlign: "center" }}>
                          <ListItemText
                            primary={ currentUserFullName }
                            secondary={ currentUserOganizationName }
                            style={{ textAlign: "center", paddingRight: 0 }}
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemText
                            primary="Email"
                            secondary={currentUser.email_verified ? currentUser.email : currentUser.email + ' (Not verified)'}
                          />

                        </ListItem>
                        {currentUser.user_metadata && currentUser.user_metadata.phoneNumber ?
                          <ListItem>
                            <ListItemText
                              primary="Phone number"
                              secondary={currentUser.user_metadata.phoneNumber}
                            />
                          </ListItem> :
                          <div></div>}
                        {currentUser.user_metadata && currentUser.user_metadata.number ?
                          <ListItem>
                            <ListItemText
                              primary="Address"
                              secondary={currentUser.user_metadata.number + ' ' + currentUser.user_metadata.street + ', ' + currentUser.user_metadata.zip + ' ' + currentUser.user_metadata.city + ', ' + currentUser.user_metadata.region + ' (' + currentUser.user_metadata.country + ')'}
                            />
                          </ListItem> :
                          <div></div>}
                        {currentUser.app_metadata && currentUser.app_metadata.roles ?
                          <ListItem>
                            <ListItemText
                              primary="Role(s)"
                              secondary={currentUser.app_metadata.roles.map(role => ' ' + role + ' | ')}
                            />
                          </ListItem>
                          : <div></div>
                        }
                        {currentUser.app_metadata && currentUser.app_metadata.roles && currentUser.app_metadata.roles.includes(enums.UserRole.CUSTOMER) &&
                          <div>
                            <ListItem>
                              <ListItemText
                                primary="Associated Consuming Assets"
                              />
                            </ListItem>
                            {currentUser.user_metadata && currentUser.user_metadata.consumingAssets && currentUser.user_metadata.consumingAssets.length > 0 ?
                              currentUser.user_metadata.consumingAssets.map(consumingAsset => {
                                return(
                                  <ListItem>
                                    <ListItemText
                                    secondary={consumingAsset.displayedName}/>
                                  </ListItem>
                                )
                              })
                              :
                              <ListItem>
                                <ListItemText
                                  secondary="ALL organization consuming assets"
                                />
                              </ListItem>
                            }
                          </div>
                        }
                      </List>
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

User.contextTypes = {
  router: PropTypes.object
}
User.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ usersReducer, router, loginReducer, utilsReducer }) => {
  const { currentUser, loading } = usersReducer;
  const { unit } = utilsReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  return { currentUser, loading, location, isAuthenticated, username, user, unit };
};



const mapDispatchToProps = {
  getUserStart,
  saveProducingSmartMeterRead,
  setUnit
}


//const MyConnectedComponent = withRouter(connect(mapStateToProps)(MyComponent))

User = withStyles(styles, { name: 'User' })(User);
User = translate("translations")(User);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(User))



// WEBPACK FOOTER //
// ./src/components/User.js